import Vue from 'vue';
// tslint:disable-next-line: variable-name
export const EventBus = new Vue();
